import { Route, Routes } from "react-router-dom";
import RegionMapScreen from "screens/App/CRM/Locations/Region/MapScreen/RegionMapScreen.js";
import RegionCreateScreen from "screens/App/CRM/Locations/Region/RegionCreateScreen.js";
import RegionDetailScreen from "screens/App/CRM/Locations/Region/RegionDetailScreen.js";
import RegionEditScreen from "screens/App/CRM/Locations/Region/RegionEditScreen.js";
import RegionListScreen from "screens/App/CRM/Locations/Region/RegionListScreen.js";
import NotFoundScreen from "screens/NotFoundScreen";

const RegionRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<RegionCreateScreen />}></Route>
      <Route path=":id/detail" element={<RegionDetailScreen />}></Route>
      <Route path=":id/edit" element={<RegionEditScreen />}></Route>
      <Route path="list" element={<RegionListScreen />}></Route>
      <Route path="map" element={<RegionMapScreen />}></Route>
      <Route path="*" element={<NotFoundScreen />}></Route>
    </Routes>
  );
};

export default RegionRouter;
